import React, { useMemo, useState } from "react";
import { Table } from "@mui/material";

import { materialsStyles } from "../../styles/materials/materialsTableStyles";
import { CM_ORDER_DATE } from "../../utils/consts/materialsConsts";
import { getAbasDateTime } from "../../utils/materialsUtils";

import { MaterialsTableBody } from "./MaterialsTableBody";
import { MaterialsTableHead } from "./MaterialsTableHead";

const compareByDate = (aValue, bValue, sortDirection) => {
  const aTime = getAbasDateTime(aValue);
  const bTime = getAbasDateTime(bValue);
  const aIsInvalid = Number.isNaN(aTime);
  const bIsInvalid = Number.isNaN(bTime);

  // Rows without a usable date sink to the bottom in both directions.
  if (aIsInvalid && bIsInvalid) return 0;
  if (aIsInvalid) return 1;
  if (bIsInvalid) return -1;

  const result = aTime - bTime;
  return sortDirection === "asc" ? result : -result;
};

const compareByValue = (aValue, bValue, sortDirection) => {
  if (aValue === bValue) return 0;
  const result = aValue > bValue ? 1 : -1;
  return sortDirection === "asc" ? result : -result;
};

export const MaterialsTable = ({ materials }) => {
  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const handleSort = (column) => {
    if (sortBy !== column) {
      setSortBy(column);
      setSortDirection("asc");
      return;
    }
    if (sortDirection === "asc") {
      setSortDirection("desc");
    } else {
      setSortBy(null);
      setSortDirection(null);
    }
  };

  const sortedMaterials = useMemo(() => {
    const rows = Array.isArray(materials) ? [...materials] : [];
    if (!sortBy) return rows;

    return rows.sort((a, b) =>
      sortBy === CM_ORDER_DATE
        ? compareByDate(a[sortBy], b[sortBy], sortDirection)
        : compareByValue(a[sortBy], b[sortBy], sortDirection)
    );
  }, [materials, sortBy, sortDirection]);

  return (
    <Table sx={materialsStyles.table}>
      <MaterialsTableHead
        sortBy={sortBy}
        sortDirection={sortDirection}
        onSort={handleSort}
      />
      <MaterialsTableBody materials={sortedMaterials} />
    </Table>
  );
};
